<template>
    <div class="program-box">
        <ChildbannerTwo ref='childbannertwon' class="white"></ChildbannerTwo>
        <div class="main-box" v-if='mainShow'>
            <DoBetter :childModle='childModleData' id='programdobetter' class="black"></DoBetter>
            <Features class="black"></Features>
            <OurServe :serveData='serveData' :swiperOptions='swiperOptions' :scrollbar='scrollbar' class="black">
            </OurServe>
            <Explain class="black"></Explain>
            <FromBanner :msg='msg' class="white"></FromBanner>
        </div>
        <div class="child-box" v-else>
            <router-view />
        </div>
    </div>
</template>
<script>
    import ChildbannerTwo from '@/components/base/childbannertwo'//引入子banner
    import DoBetter from '@/components/main/contact/dobetter'//引入页面说明
    import Features from '@/components/main/project/features'//引入设计师说明     
    import OurServe from '@/components/main/home/ourserve'//引入案例墙
    import Explain from '@/components/main/project/explain'//引入说明
    import FromBanner from '@/components/base/frombanner'//引入联系我们的banner模块
    export default {
        name: 'Program',
        data() {
            return {
                mainShow: true,
                childModleData: {
                    caption: 'Let us build it',
                    captionShadown: 'Let us build it',
                    center: '每一个成功、专业的网站都将由我们项目经理、设计师，前端技术开发，客户多方合力，约在45天的工期里共同完成，而通过我们极致的建站标准化流程，5+客户电话会议，10+原型设计页修改，50+道建站工序流程，为客户还原自己心目中的网站。',
                    title: '定制独立站',
                },
                serveData: {//第三屏的数据
                    caption: 'Check out these websites we designed',
                    title: '成功案例 successful case',
                    swiperData: [
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/kuaiqi.png',
                            caption: '时尚类网站',
                            title: '<p>记得第一次见到 这家客户时，他说希望自己的品牌官简约大方， 要有国际范大公司样子，突显品牌，展现设计美感，最重要的是能够有记忆点，有特色，让海外客户印象深刻。</p>'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/yl2.png',
                            caption: '工业类网站',
                            title: '<p>水暖地热是属于较冷门的行业，我们在网站里加入企业责任、制造流程、质量优势、公司特色等多样化的描述，为海外客户打造了一个有人文关怀同时实力雄厚、品质过硬的企业形象。</p>'
                        },
                    ]
                },
                msg: {
                    caption: '诊断您的网站SEO布局和关键词布局定制海外营销计划',
                    botton: '免费咨询',
                },
                swiperOptions: {
                    // autoplay: { //匀速滚动
                    //     delay: 3000, //间隔时间0秒
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false, //触摸后仍然执行
                    // },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        hide: false
                    },
                    mousewheel: true,
                    slidesPerView: 1.5,
                    spaceBetween: 48,
                    grabCursor: true
                    // Some Swiper option/callback...
                },
                scrollbar: '#000000'
            }
        },
        components: {
            ChildbannerTwo,
            DoBetter,
            Features,
            OurServe,
            Explain,
            FromBanner
        },
        mounted() {
            this.getPath()
        },
        methods: {
            getPath() {//控制当前页面的子页面展现
                if (this.$route.path !== '/program') {
                    this.mainShow = false
                } else {
                    this.mainShow = true
                }
            },
            childMethods() {//控制子组件内容
                this.$refs.childbannertwon.changeShow()
            }
        }
    }
</script>
<style scoped>
    .program-box>>>.DoBetter {
        padding: 0px 0 260px 0;

    }

    .main-box>>>.DoBetter {
        margin-top: 344px;
    }

    .program-box>>>.center-box::after {
        top: -232px;
    }

    .DoBetter>>>.center-caption {
        bottom: 0;
        right: 0;
        font-size: 200px;
        transform: translateY(-58%);
    }

    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.title-caption {
        font-size: 30px;
        font-weight: 400;
        line-height: 42px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 80px;
        position: relative;
    }

    .DoBetter>>>.title-caption::before {
        content: 'Custom website';
        display: block;
        text-transform: uppercase;
        position: absolute;
        top: 0;
        left: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        white-space: nowrap;
        color: rgba(36, 136, 248, 1);
        transform: translateY(-150%);
    }

    .DoBetter>>>.center-box::before {
        display: none;
    }

    .program-box>>>.DoBetter::before,
    .program-box>>>.animetionLine,
    .program-box>>>.animetionLine::after {
        display: block;
    }

    .program-box>>>.center-caption-f {
        position: absolute;
        right: 0;
        display: block;
        white-space: nowrap;
        font-family: gilroybold4;
        font-size: 200px;
        font-weight: bold;
        line-height: 290px;
        text-transform: capitalize;
        color: #F1F1F1;
        -webkit-text-stroke: 3px rgba(255, 255, 255, 1);
        text-stroke: 3px rgba(255, 255, 255, 1);
    }

    .ourserve-box {
        margin-top: 0;
        margin-bottom: 138px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/space_img_project_01.jpg') no-repeat center center;
        background-attachment: fixed;
    }

    .ourserve-box>>>.caption {
        font-size: 30px;
        line-height: 35px;
        position: relative;
        max-width: 352px;
    }

    .ourserve-box>>>.title {
        margin-top: 36px;
        font-size: 16px;
        line-height: 200%;
        max-width: 114px;
    }

    .ourserve-box>>>.text-box {
        padding: 211px 0 0 163px;
    }

    .ourserve-box>>>.animetionLine,
    .ourserve-box>>>.animetionLine::after,
    .ourserve-box::before {
        display: block;
    }

    @media(max-width: 1409px) {
        .DoBetter>>>.center-caption {
            bottom: 0;
            right: 0;
            font-size: 110px;
            transform: translateY(-58%);
        }

        .program-box>>>.center-caption-f {
            font-size: 110px;
            line-height: 145%;
        }
    }

    @media(max-width: 995px) {

        .DoBetter>>>.center-caption,
        .program-box>>>.center-caption-f,
        .main-box>>>.DoBetter::before,
        .main-box>>>.animetionLine {
            display: none;
        }

        .main-box>>>.DoBetter {
            margin-top: 0;
            padding-bottom: 0;
        }

        .DoBetter>>>.center-box {
            min-height: auto;
        }

        .DoBetter>>>.title-caption {
            left: 5%;
            margin-bottom: 0;
        }

        .DoBetter>>>.mobile-img {
            display: block;
            background: red url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1467232004584-a241de8bcf5d.jpg') no-repeat top;
            background-size: cover;
            width: 100%;
            height: 80vw;
        }

        .main-box>>>.ourserve-box {
            background: transparent url(https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/space_img_project_01.jpg) no-repeat center;
            background-size: cover;
            background-attachment: initial;
            margin-bottom: 10%;
        }

        .ourserve-box>>>.text-box {
            padding: 10% 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .ourserve-box>>>.caption {
            max-width: 100%;
            text-align: center;
        }

        .ourserve-box>>>.title {
            margin-top: 0;
            font-size: 16px;
            line-height: 200%;
            max-width: 100%;
            padding: 5% 0;
        }

        .ourserve-box>>>.button {
            margin: 0;
        }
    }

    /* @media(max-width: 1023px) {

        .ourserve-box>>>.animetionLine,
        .ourserve-box>>>.animetionLine::after,
        .ourserve-box::before {
            display: none;
        }

        .program-box>>>.DoBetter::before,
        .program-box>>>.animetionLine,
        .program-box>>>.animetionLine::after {
            display: none;
        }

        .main-box .DoBetter>>>.center-box::after {
            display: none;
        }

        .main-box .DoBetter>>>.center-caption {
            bottom: 100%;
            right: 0;
            transform: translateY(10%);
        }

        .main-box .DoBetter>>>.center-caption-f {
            display: none;
        }

        .main-box .DoBetter>>>.center-box {
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1467232004584-a241de8bcf5d.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
        }

        .main-box .DoBetter>>>.text-center {
            font-size: 60px;
            transform: translateY(40%);
        }

        .main-box .DoBetter>>>.title-caption {
            font-size: 60px;
            font-weight: 400;
            line-height: 175%;
            color: rgba(36, 136, 248, 1);
            left: 5%;
            top: 12%;
        }

        .main-box .DoBetter>>>.title-caption::before {
            font-size: 50px;
            color: #ffffff;
            line-height: 110%;
        }

        .main-box .ourserve-box {
            margin-top: 0;
            margin-bottom: 138px;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/space_img_project_01.jpg') no-repeat center;
            background-attachment: initial;
            background-size: cover;
        }

        .main-box .DoBetter {
            padding-bottom: 500px;
        }
        .ourserve-box>>>.twoswiper{
            height: 1800px;
        }

        .ourserve-box>>>.caption {
            font-size: 75px;
            line-height: 116%;
            max-width: 60%;
        }

        .ourserve-box>>>.title {
            font-size: 60px;
            line-height: 200%;
            max-width: 30%;
        }
    }
    @media(max-width: 320px){
        .ourserve-box>>>.twoswiper{
            height: 2200px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/program.vue